import { OutlinedTextFields } from '@Components';
import { CORPORATE, CORPORATE_USD_MAX_LENGTH_COUNTRIES, INDIVIDUAL } from '@Utils/constants';
import {
  alphanumericWithDotAndSpace,
  alphanumericWithDotAndSpaceAndParenthesisAndAmpersand,
  alphaWithDotAndSpace,
  fullNameValidation,
  r_maxLength,
  required
} from '@Utils/validation';
import React from 'react';
import { Field, getFormValues } from 'redux-form';
import { useSelector } from 'react-redux';
import { IBeneNameContainer } from '../utils/types';
import { Col } from '../../../../nium-forex/styles';
import { NameFieldsContainer, BeneIdentityHelperText } from '../styles';
import { BENE_NAME_HELPER_TEXT, BENE_NAME_INCOMPLETE_HELPER_TEXT } from '../utils/constants';
import { BENE_PERSONAL_DETAILS_FORM_NAME } from '../../../constants/commons';
import { IStore } from '../../../../../store.type';

const NameField: React.FC<IBeneNameContainer> = ({
  account_type,
  bank_account_country,
  currency_code,
  is_partially_editable,
  is_completely_editable
}) => {
  const formValues = useSelector((state: IStore) =>
    getFormValues(BENE_PERSONAL_DETAILS_FORM_NAME)(state)
  ) as any;
  const beneficiaryName = (formValues?.beneficiary_name || '').trim();
  const isLastNameMissing = beneficiaryName.length > 2 && /^\S+$/.test(beneficiaryName);
  const helperText = isLastNameMissing ? BENE_NAME_INCOMPLETE_HELPER_TEXT : BENE_NAME_HELPER_TEXT;
  const setCompanyNameLength = () => {
    if (account_type === CORPORATE) {
      if (
        CORPORATE_USD_MAX_LENGTH_COUNTRIES.includes(bank_account_country) &&
        currency_code === 'USD'
      ) {
        return 100;
      }
      if (bank_account_country === 'CN' && currency_code === 'CNY') {
        return 60;
      }
    }
    return 50;
  };

  let isCorpIndiaBeneWithINRCurrency = false,
    isCorpChinaBeneWithCNYCurrency = false;
  if (account_type === CORPORATE && bank_account_country === 'IN' && currency_code === 'INR') {
    isCorpIndiaBeneWithINRCurrency = true;
  }
  if (account_type === CORPORATE && bank_account_country === 'CN' && currency_code === 'CNY') {
    isCorpChinaBeneWithCNYCurrency = true;
  }

  const corpIndiaCompanyNameRules = [required, alphaWithDotAndSpace];
  const corpChinaCompanyNameRules = [
    required,
    alphanumericWithDotAndSpaceAndParenthesisAndAmpersand
  ];
  const defaultCompanyNameRules = [required, alphanumericWithDotAndSpace];

  const getCompanyNameValidationRules = () => {
    if (isCorpIndiaBeneWithINRCurrency) return corpIndiaCompanyNameRules;
    if (isCorpChinaBeneWithCNYCurrency) return corpChinaCompanyNameRules;
    return defaultCompanyNameRules;
  };

  if (account_type === CORPORATE)
    return (
      <Col width={450}>
        <Field
          name="company_name"
          type="text"
          component={OutlinedTextFields}
          normalize={r_maxLength(setCompanyNameLength())}
          validate={getCompanyNameValidationRules()}
          placeholder="Company name"
          disabled={is_partially_editable && !is_completely_editable}
        />
      </Col>
    );

  if (account_type === INDIVIDUAL) {
    return (
      <NameFieldsContainer>
        <Col width={450}>
          <Field
            name="beneficiary_name"
            type="text"
            component={OutlinedTextFields}
            normalize={r_maxLength(60)}
            validate={fullNameValidation}
            placeholder="Full name"
            disabled={is_partially_editable && !is_completely_editable}
          />
        </Col>
        <BeneIdentityHelperText $marginTop={'6px'}>{helperText}</BeneIdentityHelperText>
      </NameFieldsContainer>
    );
  }

  return <></>;
};

export default NameField;
